export const domainCompanyid = {
  TD_KAMPUS: 6756,
  BIDZAAR: 7851,
  ABSOLUTE: 5451,
  ALM: [8301, 8151],
  VVPGROUP: 17252,
  TD: 6756,
};

export const isTDCompany = company => {
  return company?.id === domainCompanyid.TD;
};

export const isAbsoluteCompany = company => {
  return company?.id === domainCompanyid.ABSOLUTE;
};

export default domainCompanyid;
